import { v4 as uuid } from 'uuid'
import { WappMode } from '@weblite-wapps/protocol'

const slashJoin = (...args: string[]) => args.filter(Boolean).join('/')

export const generateWappSessionId = () => uuid() as string

export const generateWappElementName = ({
  wappSessionId,
  wappId,
  wisId = null,
  mode,
}: {
  wappSessionId: string
  wappId: string
  wisId?: string
  mode: WappMode
}) => slashJoin(wappSessionId, wappId, mode, wisId)
